// This is setting the public path of webpack bundle, needed to be run before any other ES6 import
import './setWebpackPublicPath';
import './index.css';
import { setUsingReactShellPromise } from '@office-start/shell-utilities-store';
import { renderAppHosted } from './renderAppHosted';
import { renderPwaOhome } from './renderPwaOhome';
import { renderReactOhome } from './renderReactOhome';
import { loadShellBootstrapper } from './shellLoader';
// tell shell rendered promise that application is loading via React
setUsingReactShellPromise();
Object.defineProperty(window, 'ReactOhomeShim', {
    get: function () {
        return {
            renderReactOhome: renderReactOhome,
            renderPwaOhome: renderPwaOhome,
            renderAppHosted: renderAppHosted,
            loadShellBootstrapper: loadShellBootstrapper,
        };
    },
});
if (typeof window.appBundleExecutedResolver === 'function') {
    window.appBundleExecutedResolver();
}
